import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { caseDetailsI18n } from './i18n';

const AddUserModal = ({
  DesignSystemComponents,
  show,
  onClose,
  lawyers,
  onSearch,
  onAdd,
}) => {
  const { t } = useTranslation(undefined, { i18n: caseDetailsI18n });
  const { Input, Modal, Card, Button } = DesignSystemComponents;
  const [search, setSearch] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearch && onSearch(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <Modal
      title={t('caseDetails_modalTitle')}
      show={show}
      onClose={onClose}
      secondaryBtnTxt={t('caseDetails_closeModalButton')}
      secondaryBtnAction={onClose}
      ctaAligment='left'
      width='40vw'
    >
      <p className='font-light mb-2'> {t('caseDetails_modalSearchUser')}</p>
      <Input
        icon='search'
        name='searchLawyer'
        placeholder={t('caseDetails_modalPlaceholder')}
        type='text'
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <p className='font-light mb-2'>{`${lawyers?.length} ${t('caseDetails_modalAviableUsers')}`}</p>

      {lawyers?.length > 0 &&
        lawyers.map((item, i) => (
          <Card className='mt-3' key={i}>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center gap-3'>
                <div>
                  <span className='fw-semibold d-block'>{item.name}</span>
                  <span className='font-light d-block'>
                    {item.roleName} • {item.email}
                  </span>
                </div>
              </div>
              <Button
                label={t('caseDetails_addUserButton')}
                variant='primary'
                size='sm'
                iconStart='plusLg'
                onClick={() => onAdd(item)}
              />
            </div>
          </Card>
        ))}
    </Modal>
  );
};
export default AddUserModal;
